const data = {
  'Selected': '{0}個中{1}個を選択中',
  'Uploading files': '{1}中{0}%をアップロードしています…',
  'File size error': '{0}が大きすぎます。{1}未満のファイルのみアップロードできます。',
  'Upload failed': '{0}のアップロードに失敗しました。',
  'Upload summary': '成功 {0}、失敗 {1}、合計 {2}',
  'Per page': '{0}個表示',
  'Folder': 'フォルダ',
  'Login failed, please try again': 'ログインに失敗しました。もう1度お試しください。',
  'Already logged in': '既にログインしています。',
  'Please enter username and password': 'ユーザー名とパスワードを入力してください。',
  'Not Found': '見つかりません。',
  'Not Allowed': '許可されていません。',
  'Please log in': 'ログインしてください',
  'Unknown error': '不明なエラー',
  'Add files': 'アップロード',
  'New': '新規',
  'New name': '新しい名前',
  'Username': 'ユーザー名',
  'Password': 'パスワード',
  'Login': 'ログイン',
  'Logout': 'ログアウト',
  'Profile': 'プロフィール',
  'No pagination': 'ページネーションなし',
  'Time': '更新日',
  'Name': '名前',
  'Size': 'サイズ',
  'Home': 'ホーム',
  'Copy': 'コピー',
  'Move': '移動',
  'Rename': '名前の変更',
  'Required': 'このフィールドを記入してください。',
  'Zip': 'Zip',
  'Batch Download': 'バッチダウンロード',
  'Unzip': 'Zipを解凍',
  'Delete': '削除',
  'Download': 'ダウンロード',
  'Copy link': 'リンクをコピー',
  'Done': '完了',
  'File': 'ファイル',
  'Drop files to upload': 'アップロードするファイルをドロップしてください。',
  'Close': '閉じる',
  'Select Folder': 'フォルダを選択',
  'Users': 'ユーザー',
  'Files': 'ファイル',
  'Role': 'ロール',
  'Cancel': 'キャンセル',
  'Paused': '一時停止',
  'Confirm': '確認',
  'Create': '作成',
  'User': 'ユーザー',
  'Admin': '管理者',
  'Save': '保存',
  'Read': '読み込み',
  'Write': '書き込み',
  'Upload': 'アップロード',
  'Permissions': '権限',
  'Homedir': 'ホームフォルダ',
  'Leave blank for no change': '変更しない場合は空白のままにしてください',
  'Are you sure you want to do this?': '実行してもよろしいですか？',
  'Are you sure you want to allow access to everyone?': '全員にアクセスを許可してよろしいですか？',
  'Are you sure you want to stop all uploads?': '全てのアップロードを中止してよろしいですか？',
  'Something went wrong': '問題が発生したようです。',
  'Invalid directory': '無効なフォルダ',
  'This field is required': 'この項目は必須です。',
  'Username already taken': 'ユーザー名が既に使用されています。',
  'User not found': 'ユーザーが見つかりません。',
  'Old password': '以前のパスワード',
  'New password': '新しいパスワード',
  'Wrong password': 'パスワードが間違っています。',
  'Updated': '更新しました。',
  'Deleted': '削除しました。',
  'Your file is ready': 'ファイルの準備ができました。',
  'View': '表示',
  'Show symbolic format': 'シンボリック形式を表示',
  'Hide symbolic format': 'シンボリック形式を非表示',
}

export default data
